import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined"
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined"
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined'
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined'
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined'

const OrderMenu = {
    id: 'ordersRoot',
    title: 'INVENTORY',
    type: 'group',
    children: [
        {
            id: 'orders',
            title: 'Customer Orders',
            type: 'item',
            url: '/orders',
            breadcrumbs: false,
            icon: ShoppingCartOutlinedIcon
        },
        {
            id: 'purchaseorders',
            title: 'Purchase Orders',
            type: 'item',
            url: '/purchaseOrder',
            breadcrumbs: false,
            icon: AddShoppingCartOutlinedIcon
        },
        {
            id: 'treatments',
            title: 'Treatment Usage',
            type: 'item',
            url: '/treatments/usage',
            breadcrumbs: false,
            icon: MedicalServicesOutlinedIcon
        },   
        {
          id: 'inventoryAdjustments',
          title: 'Inventory Adjustments',
          type: 'item',
          url: '/inventory/adjustments',
          breadcrumbs: false,
          icon: InventoryOutlinedIcon
        },
        {
          id: 'inventory',
          title: 'Inventory',
          type: 'item',
          url: '/inventory',
          breadcrumbs: false,
          icon: StoreOutlinedIcon
        }
          
        // {
        //     id: 'lowStockList',
        //     title: 'Low Stock List',
        //     type: 'item',
        //     url: '/lowStockList',
        //     icon: ShoppingCartOutlinedIcon,
        //     breadcrumbs:false
        // },

        // {
        //     id: 'inventoryBarChart',
        //     title: 'Inventory Chart',
        //     type: 'item',
        //     url: '/inventory/barchart',
        //     icon: ShoppingCartOutlinedIcon,
        //     breadcrumbs:false
        // }
    ]
}

export default OrderMenu